export enum BidderSequence {
  fixed = 'fixed',
  random = 'random'
}
